/** PURE_IMPORTS_START ._root PURE_IMPORTS_END */
import { root } from './root';
export function minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return (function () {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function (value) {
            if (!this.has(value)) {
                this._values.push(value);
            }
        };
        MinimalSet.prototype.has = function (value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function () {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function () {
            this._values.length = 0;
        };
        return MinimalSet;
    }());
}
export var Set = root.Set || /*@__PURE__*/ minimalSetImpl();
//# sourceMappingURL=Set.js.map



//////////////////
// WEBPACK FOOTER
// /app/node_modules/rxjs/_esm5/util/Set.js
// module id = null
// module chunks = 